import React, { useState, useMemo, useEffect, useCallback } from "react";
import {
  Container,
  Row,
  Col,
  Button,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Badge,
  Table,
  Input,
  Card,
  CardBody
} from "reactstrap";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import UiContent from "../../Components/Common/UiContent";
import { postDataAPI } from "../../helpers/phpbackend_helper";
import { getLoggedinUser, getDateByName } from "../../helpers/api_helper";
import CustomDatePicker from "../../Components/Common/CustomDatePicker";

// const DATE_FILTER_MAP = {
//   "This Month": "ThisMonth",
//   "Last Month": "LastMonth",
//   "This Week": "ThisWeek",
//   "Past Two Weeks": "PastTwoWeeks",
//   "This Year": "ThisYear",
//   "Last Year": "LastYear",
//   Yesterday: "Yesterday",
// };

// const getDateFilterPayload = (dateFilter) => {
//   if (!dateFilter) return null;
//   if (typeof dateFilter === "object") return dateFilter;

//   const filterName = DATE_FILTER_MAP[dateFilter] || dateFilter.replace(/\s+/g, "");
//   return getDateByName(filterName);
// };

const FILTER_OPTIONS = {
  "Day of Week": {
    field: "day",
    options: [
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
      "Sunday",
    ],
  },
  "Service Periods": {
    field: "service_periods",
    options: ["Breakfast", "Lunch", "Dinner"],
  },
  // "Table Occupancy": ["0-10%", "10-20%", "20-30%", "30-40%", "40-50%", "50-60%", "60-70%", "70-80%", "80-90%", "90-100%"],
  // "Seat Occupancy": ["0-10%", "10-20%", "20-30%", "30-40%", "40-50%", "50-60%", "60-70%", "70-80%", "80-90%", "90-100%"],
  "Master Class": {
    field: "master_class",
    options: ["Alc Beverages", "Food", "Others"],
  },
  // "Master Class": ["Alc Beverages", "Food", "Others"],
  // "Universal Class": ["Alc Beverages", "Food", "Others"],
  "Courses": {
    field: "courses",
    options: ["Alc Beverages", "Food", "Others", "Main"],
  },
  "Food Items": {
    field: "food_items",
    options: ["Ceasr salad", "Pad thai", "Green Curry"],
  },
  // "Food Items": ["Ceasr salad", "Pad thai", "Green Curry"],
  "Drinks Items": {
    field: "drinks_items",
    options: ["Espress", "Cappuccino", "Fresh OJ"],
  },
  // "Drinks Items": ["Espress", "Cappuccino", "Fresh OJ"],
  "Alcoholic / Non-Alcoholic": {
    field: "alcoholic___non_alcoholic",
    options: ["Alcoholic", "Non-Alcoholic"],
  },
  // "Hours of day": ["00:00", "01:00", "02:00", "03:00", "04:00"],
  "Discounts": {
    field: "discounts",
    options: ["50% Staff Discount", "AMEX 35%", "UOB 20%"],
  },
  // "Discounts": ["50% Staff Discount", "AMEX 35%", "UOB 20%"],
  "Type": {
    field: "type",
    options: ["Bar Snacks", "Beer", "Buffet"],
  },
  "Server": {
    field: "server",
    options: ["Sarah Johnsen", "Mike Chen", "Emily Devis"],
  },
  // "Portfolio Analysis": ["Star", "Cash Cow", "Puzzle", "Dog"],
  "Menu Item": {
    field: "menu_item",
    options: ["Ceaser Salad", "Grilled Salmon", "Pad Thai"],
  },
  "Menu Item": ["Ceaser Salad", "Grilled Salmon", "Pad Thai"]
};

const DEFAULT_COLUMNS = [
  { key: "covers", label: "Covers", visible: true },
  { key: "avg", label: "Avg Check", visible: true },
  { key: "revenue", label: "Revenue", visible: true },
  { key: "itemcost", label: "Item Cost", visible: true },
  { key: "grossprofit", label: "Gross Profit", visible: true },
  { key: "total_cost", label: "Total Cost", visible: false },
  { key: "total_sales", label: "Total Sales", visible: false },
  { key: "sales_mix", label: "Sales Mix", visible: false },
  { key: "revenueMix", label: "Revenue Mix", visible: false },
  { key: "ContributionMargin", label: "Contribution Margin", visible: false, conditional: true,
    requiredFilters: ["Food Items", "Drink Items", "Menu Item"]},
  { key: "profit_contribution", label: "Profit Contribution", visible: false },
  { key: "popularity_contribution", label: "Popularity Contribution", visible: false },
  { key: "performance_group", label: "Performance Group", visible: false },
];
const COLUMN_META = {
  covers: { type: "triple", bg: "#E3F2FD" },
  avg: { type: "triple", bg: "#E8F5E9" },
  revenue: { type: "triple", bg: "#FFF3E0" },
  itemcost: { type: "triple", bg: "#F3E5F5" },
  grossprofit: { type: "triple", bg: "#E0F7FA" },

  total_cost: { type: "triple", bg: "#FCE4EC" },
  total_sales: { type: "triple", bg: "#F1F8E9" },
  sales_mix: { type: "double", bg: "#FFF8E1" },
  revenueMix: { type: "double", bg: "#EDE7F6" },
  ContributionMargin: { type: "double", bg: "#F9FBE7", multiline: true },
  profit_contribution: { type: "double", bg: "#E8EAF6", multiline: true },
  popularity_contribution: { type: "double", bg: "#FBE9E7", multiline: true },
  performance_group: { type: "double", bg: "#ECEFF1", multiline: true },
};

const MOCK_DATA = [
  {
    dateRange: "Feb 1 - Feb 28, 2026",
    day: "Monday",
    occupancy: "10-20%",
    coversCurrent: 41,
    coversLast: 38,
    avgCurrent: 227,
    avgLast: 33,
    revenueCurrent: 9319,
    revenueLast: 1241,
  },
  {
    dateRange: "Feb 1 - Feb 28, 2026",
    day: "Tuesday",
    occupancy: "0-10%",
    coversCurrent: 37,
    coversLast: 46,
    avgCurrent: 217,
    avgLast: 24,
    revenueCurrent: 8013,
    revenueLast: 1086,
  },
];

// Define day order mapping
const DAY_ORDER = {
  "Monday": 1,
  "Tuesday": 2,
  "Wednesday": 3,
  "Thursday": 4,
  "Friday": 5,
  "Saturday": 6,
  "Sunday": 7
};

export default function PlaygroundNew() {
  const [filters, setFilters] = useState([]);
  const [appliedFilters, setAppliedFilters] = useState([]);
  const [addFilterOpen, setAddFilterOpen] = useState(false);
  const [columnsOpen, setColumnsOpen] = useState(false);
  const [columns, setColumns] = useState(DEFAULT_COLUMNS);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  // const [dateFilter, setDateFilter] = useState("This Month");
  const [filterOptions, setFilterOptions] = useState(FILTER_OPTIONS);
  const [leftFilter, setLeftFilter] = useState({
    label: "Yesterday",
    value: "Yesterday",
  });
  const [leftCustomDate, setLeftCustomDate] = useState([]);

  // Create a Date object from the original date string
  var originalDate = new Date(leftCustomDate[0]);

  // Extract the year, month, and day from the Date object
  var year = originalDate.getFullYear();
  var month = (originalDate.getMonth() + 1).toString().padStart(2, "0"); // Month is zero-based, so add 1
  var day = originalDate.getDate().toString().padStart(2, "0");

  // Create the formatted date string
  var datefrom = year + "-" + month + "-" + day;

  // Create a Date object from the original date string
  var originalDate2 = new Date(leftCustomDate[1]);

  // Extract the year, month, and day from the Date object
  var year2 = originalDate2.getFullYear();
  var month2 = (originalDate2.getMonth() + 1).toString().padStart(2, "0"); // Month is zero-based, so add 1
  var day2 = originalDate2.getDate().toString().padStart(2, "0");

  // Create the formatted date string
  var dateto = year2 + "-" + month2 + "-" + day2;

  const loadDynamicFilters = useCallback(async () => {
    try {
      const userInfo = getLoggedinUser();

      const payload = {
        op: "drill_summary_filters",
        serviceName: "kpi_data",
        selectedOutletID: userInfo?.selectedOutletID,
        dateFilter:
          leftFilter.value === "Custom"
            ? { from: datefrom, to: dateto }
            : getDateByName(leftFilter.value),
      };

      const response = await postDataAPI(payload);

      const updatedFilters = { ...FILTER_OPTIONS };

      if (response?.data?.service_periods) {
        updatedFilters["Service Periods"] = {
          field: "service_periods",
          options: response.data.service_periods.map((item) => ({
            label: item.title,
            value: item.sp_id,
          })),
        };
      }
      if (response?.data?.master_class) {
        updatedFilters["Master Class"] = {
          field: "master_class",
          options: response.data.master_class.map((item) => ({
            label: item.master_class_name,
            value: item.master_class_id,
          })),
        };
      }
      if (response?.data?.course) {
        updatedFilters["Courses"] = {
          field: "courses",
          options: response.data.course.map((item) => ({
            label: item.course_name,
            value: item.course_id,
          })),
        };
      }
      if (response?.data?.server) {
        updatedFilters["Server"] = {
          field: "server",
          options: response.data.server.map((item) => ({
            label: item.server_name,
            value: item.server_id,
          })),
        };
      }
      if (response?.data?.type) {
        updatedFilters["Type"] = {
          field: "type",
          options: response.data.type.map((item) => ({
            label: item.type_name,
            value: item.type_id,
          })),
        };
      }
      if (response?.data?.menu) {
        updatedFilters["Menu Item"] = {
          field: "menu_item",
          options: response.data.menu.map((item) => ({
            label: item.menu_item_name,
            value: item.menu_item_id,
          })),
        };
      }
      if (response?.data?.discount) {
        updatedFilters["Discounts"] = {
          field: "discounts",
          options: response.data.discount.map((item) => ({
            label: item.discount_name,
            value: item.discount_number,
          })),
        };
      }
      if (response?.data?.food_items) {
        updatedFilters["Food Items"] = {
          field: "food_items",
          options: response.data.food_items.map((item) => ({
            label: item.food_item_name,
            value: item.food_item_id,
          })),
        };
      }
      if (response?.data?.drink_items) {
        updatedFilters["Drinks Items"] = {
          field: "drinks_items",
          options: response.data.drink_items.map((item) => ({
            label: item.drink_item_name,
            value: item.drink_item_id,
          })),
        };
      }

      setFilterOptions(updatedFilters);
    } catch (error) {
      console.error("Failed to load filters:", error);
    }
  }, [datefrom, dateto, leftFilter.value]);

  useEffect(() => {
    loadDynamicFilters();
  }, [loadDynamicFilters]);

  // Add filter
  const handleAddFilter = (name) => {
    // ❌ Block Table/Seat Occupancy if Service Period not added
    if (
        (name === "Table Occupancy" || name === "Seat Occupancy") &&
        !filters.find(f => f.name === "Service Periods")
    ) {
        alert("Please add Service Period filter first.");
        return;
    }

    if (!filters.find(f => f.name === name)) {
        setFilters([
          ...filters,
          { name, field: filterOptions[name].field, selected: [], open: false },
        ]);
    }
    };

  // Toggle filter dropdown
  const toggleFilterDropdown = (name) => {
    setFilters(filters.map(f =>
      f.name === name ? { ...f, open: !f.open } : f
    ));
  };

  // Select option (UI only)
  const handleOptionSelect = (filterName, option) => {
    const updated = filters.map(f => {
        if (f.name === filterName) {
        const exists = f.selected.includes(option);
        const newSelected = exists
            ? f.selected.filter(o => o !== option)
            : [...f.selected, option];

        return { ...f, selected: newSelected };
        }
        return f;
    });

    // 🔥 If Service Period has no selection → clear Table & Seat selections
    const serviceFilter = updated.find(f => f.name === "Service Periods");

    if (serviceFilter && serviceFilter.selected.length === 0) {
        updated.forEach(f => {
        if (f.name === "Table Occupancy" || f.name === "Seat Occupancy") {
            f.selected = [];
        }
        });
    }

    setFilters(updated);
    };

  // Remove filter
  const removeFilter = (name) => {
    let updated = filters.filter(f => f.name !== name);

    // 🔥 If Service Period removed → remove Table & Seat Occupancy
    if (name === "Service Periods") {
        updated = updated.filter(
        f => f.name !== "Table Occupancy" && f.name !== "Seat Occupancy"
        );
    }

    setFilters(updated);
    };

  // Apply Filters Button
  const handleApplyFilters = async () => {
    setAppliedFilters([...filters]);
    setLoading(true);

    try {
      const updatedFilters = filters.map(({ open, ...rest }) => rest);
      const userInfo = getLoggedinUser();
      const payload = {
        op: "drill_summary",
        serviceName: "kpi_data",
        selectedOutletID: userInfo?.selectedOutletID,
        dateFilter:
          leftFilter.value === "Custom"
            ? { from: datefrom, to: dateto }
            : getDateByName(leftFilter.value),
        appliedfilters: updatedFilters,
      };

      const response = await postDataAPI(payload);
      setData(response.data || []);
    } catch (error) {
      console.error("API call failed:", error);
      setData([]);
    } finally {
      setLoading(false);
    }
  };

  // Clear Filters
  const handleClearFilters = () => {
    setFilters([]);
    setAppliedFilters([]);
    setData([]);
    setLeftFilter({ label: "Yesterday", value: "Yesterday" });
    setLeftCustomDate([]);
  };

  // Sorting function
  const sortDataByFilters = (data, appliedFilters) => {
    if (!data || data.length === 0) return data;
    
    return [...data].sort((a, b) => {
      // First sort by Date Range
      const dateRangeA = a.dateRange || a.date_range || "";
      const dateRangeB = b.dateRange || b.date_range || "";
      if (dateRangeA !== dateRangeB) {
        return dateRangeA.localeCompare(dateRangeB);
      }
      
      // Then sort by each applied filter in order
      for (const filter of appliedFilters) {
        const field = filter.field;
        if (!field) continue;

        const aVal = a[field] || "";
        const bVal = b[field] || "";

        // Custom sorting for Day of Week
        if (filter.name === "Day of Week") {
          const aOrder = DAY_ORDER[aVal] || 999;
          const bOrder = DAY_ORDER[bVal] || 999;

          if (aOrder !== bOrder) {
            return aOrder - bOrder;
          }
        } else {
          // Default string comparison for other filters
          if (aVal !== bVal) {
            return String(aVal).localeCompare(String(bVal));
          }
        }
      }
      return 0;
    });
  };

  // Filtering Logic (ONLY uses appliedFilters)
  const filteredData = useMemo(() => {
    if (appliedFilters.length === 0) return data;

    let filtered = [...data];

    // appliedFilters.forEach(f => {
    //   if (f.name === "Day of Week" && f.selected.length > 0) {
    //     filtered = filtered.filter(row => f.selected.includes(row.day));
    //   }
    //   // Add other filter logic as needed
    // });

    // Sort the filtered data based on applied filter order
    filtered = sortDataByFilters(filtered, appliedFilters);

    return filtered;
  }, [appliedFilters, data]);

  const toggleColumn = (key) => {
    setColumns(columns.map(col =>
        col.key === key ? { ...col, visible: !col.visible } : col
    ));
    };

    // console.log("Applied Filters:", appliedFilters);

  const getRowSpan = (rows, rowIndex, currentFilterName = null) => {
    if (!rows || rows.length === 0) return 0;

    const currentRow = rows[rowIndex];

    // Build the list of fields to group by
    let groupFields = [];

    if (currentFilterName === null) {
      // For Date Range - group by dateRange only (no filters)
      groupFields = ["dateRange"];
    } else {
      // For filters - find the position of current filter in applied filters
      const currentFilterIndex = appliedFilters.findIndex(
        (f) => f.name === currentFilterName,
      );

      if (currentFilterIndex === -1) return 1; // Filter not found, return single row

      // Group by Date Range + all filters up to and including current filter
      const filterFields = appliedFilters
        .slice(0, currentFilterIndex + 1)
        .map((f) => f.field);

      groupFields = ["dateRange", ...filterFields];
    }

    // Create a unique key for grouping
    const makeKey = (row) => {
      return groupFields
        .map((field) => {
          let value = row[field];
          // Handle undefined/null values
          if (value === undefined || value === null) return "";
          // Convert to string for comparison
          return String(value);
        })
        .join("|");
    };

    const currentKey = makeKey(currentRow);

    // Find first occurrence of this key
    let firstIndex = -1;
    for (let i = 0; i < rows.length; i++) {
      if (makeKey(rows[i]) === currentKey) {
        firstIndex = i;
        break;
      }
    }

    // If this isn't the first occurrence, return 0 (don't render the cell)
    if (firstIndex !== rowIndex) return 0;

    // Count how many consecutive rows have the same key
    let span = 0;
    for (let i = rowIndex; i < rows.length; i++) {
      if (makeKey(rows[i]) === currentKey) {
        span++;
      } else {
        break;
      }
    }

    return span;
  };

  // Helper function to get available filters (add this before your return statement)
  const getAvailableFilters = useMemo(() => {
    return Object.keys(filterOptions).filter((name) => {
      // Exclude already applied filters
      if (filters.some((f) => f.name === name)) return false;

      // Hierarchy rules: Can't add Table/Seat Occupancy without Service Periods
      if (name === "Table Occupancy" || name === "Seat Occupancy") {
        return filters.some((f) => f.name === "Service Periods");
      }

      return true;
    });
  }, [filters, filterOptions]);

  const showContributionColumns = useMemo(() => {
    const allowedFilters = ["Food Items", "Drinks Items", "Menu Item"];

    return appliedFilters.some((filter) =>
      allowedFilters.includes(filter.name),
    );
  }, [appliedFilters]);

  return (
    <React.Fragment>
          <UiContent />
          <div className="page-content">              
            <Container fluid>
            <BreadCrumb title="Playground" pageTitle="Dashboard" />

            {/* Filters Section */}
            <Card className="mb-4">
                <CardBody>
                <Row className="align-items-end mb-3">
                    <Col md="4">
                        {/* <label className="font-weight-500">Date Range</label>
                        <Input 
                            type="select" 
                            value={dateFilter}
                            onChange={(e) => setDateFilter(e.target.value)}
                        >
                        <option>This Month</option>
                        <option>Last Month</option>
                        </Input> */}
                        <CustomDatePicker
                          activeDate={leftFilter}
                          setActiveDate={setLeftFilter}
                          customDate={leftCustomDate}
                          setCustomDate={setLeftCustomDate}
                          posEnd={false}
                        />
                    </Col>

                    <Col md="8">
                        <div className="d-flex align-items-end flex-wrap gap-2">
                        {getAvailableFilters.length > 0 && (
                          <Dropdown
                            isOpen={addFilterOpen}
                            toggle={() => setAddFilterOpen(!addFilterOpen)}
                          >
                            <DropdownToggle caret color="primary">
                              + Add Filter
                            </DropdownToggle>
                            <DropdownMenu>
                              {getAvailableFilters.map((name, index) => (
                                <DropdownItem key={index} onClick={() => handleAddFilter(name)}>
                                  {name}
                                </DropdownItem>
                              ))}
                            </DropdownMenu>
                          </Dropdown>
                        )}

                        
                        </div>
                    </Col>
                    </Row>

                {/* Dynamic Filters */}
                <Row className="g-3">
                    {filters
                        .filter(filter => {
                            if (
                            (filter.name === "Table Occupancy" ||
                            filter.name === "Seat Occupancy")
                            ) {
                            return filters.find(f => f.name === "Service Periods");
                            }
                            return true;
                        })
                        .map((filter, index) => (
                        <Col md="3" key={index}>
                        <div className="filter-box p-2">
                            <div className="d-flex justify-content-between align-items-center mb-1">
                            <label className="mb-0 font-weight-500">
                                {filter.name}
                            </label>
                            <Button
                                close
                                onClick={() => removeFilter(filter.name)}
                            />
                            </div>

                            <Dropdown
                            isOpen={filter.open}
                            toggle={() => toggleFilterDropdown(filter.name)}
                            >
                            <DropdownToggle
                                caret
                                className="w-100 text-left bg-light text-dark"
                                style={{borderColor: "lightgray"}}
                            >
                                {filter.selected.length > 0
                                ? `${filter.selected.length} selected`
                                : "Select"}
                            </DropdownToggle>

                            <DropdownMenu className="w-100 p-2 custom-dropdown-menu">
                            {filterOptions[filter.name]?.options?.map((option, i) => {
                                // console.log("option", option)
                                const selected = filter.selected.includes(
                                  option.value ? option.value : option,
                                );
                                return (
                                  <div
                                    key={i}
                                    className={`custom-option ${selected ? "selected" : ""}`}
                                    onClick={() =>
                                      handleOptionSelect(
                                        filter.name,
                                        option.value ? option.value : option,
                                      )
                                    }
                                  >
                                    <input
                                      type="checkbox"
                                      checked={selected}
                                      readOnly
                                    />
                                    {/* <div className={`custom-checkbox ${selected ? "checked" : ""}`} /> */}
                                    <span>{option.value ? option.label : option}</span>
                                  </div>
                                );
                            })}
                            </DropdownMenu>
                            </Dropdown>

                            <div className="mt-2 d-flex flex-wrap gap-1">
                            {filter.selected.map((item, i) => (
                                <Badge
                                key={i}
                                color="danger"
                                
                                className="px-2 py-1"
                                style={{ cursor: "pointer", fontSize:"smaller" }}
                                onClick={() =>
                                    handleOptionSelect(filter.name, item)
                                }
                                >
                                {/* {item} × */}
                                {
                                    filterOptions[filter.name]?.options?.find(x => x.value === item)?.label || item
                                } ×
                                </Badge>
                            ))}
                            </div>
                        </div>
                        </Col>
                    ))}
                    <Col md="3" key="aplbtn" className="pt-3">
                        <Button color="success" onClick={handleApplyFilters} className="me-2">
                            Apply Filters
                        </Button>

                        <Button color="danger" onClick={handleClearFilters}>
                            Clear All Filters
                        </Button>
                        </Col>
                    </Row>
                </CardBody>
            </Card>

            {/* Results Section */}
            <Card>
                <CardBody>
                <Row className="mb-3 align-items-center">
                    <Col>
                        <h5>Results ({filteredData.length} records)</h5>
                    </Col>

                    <Col className="text-end">
                        <Dropdown
                        isOpen={columnsOpen}
                        toggle={() => setColumnsOpen(!columnsOpen)}
                        >
                        <DropdownToggle caret color="light" className="border">
                            <i className="ri-filter-3-line" style={{ fontSize: 16 }}></i> Columns
                        </DropdownToggle>

                        <DropdownMenu right className="p-2">
                            {/* {columns.map((col, index) => (
                            <div
                                key={index}
                                className="d-flex align-items-center mb-2"
                                style={{ cursor: "pointer" }}
                                onClick={() => toggleColumn(col.key)}
                            >
                                <Input
                                type="checkbox"
                                checked={col.visible}
                                readOnly
                                className="me-2"
                                />
                                {col.label}
                            </div>
                            ))} */}
                            {columns.map((col, index) => {
                              const isContributionColumn = [
                                "ContributionMargin",
                                "profit_contribution",
                                "popularity_contribution",
                                "performance_group"
                              ].includes(col.key);

                              const disabled = isContributionColumn && !showContributionColumns;

                              return (
                                <div
                                  key={index}
                                  className={`d-flex align-items-center mb-2 ${
                                    disabled ? "text-muted" : ""
                                  }`}
                                  style={{
                                    cursor: disabled ? "not-allowed" : "pointer",
                                    opacity: disabled ? 0.5 : 1
                                  }}
                                  onClick={() => {
                                    if (!disabled) toggleColumn(col.key);
                                  }}
                                >
                                  <Input
                                    type="checkbox"
                                    checked={col.visible && !disabled}
                                    disabled={disabled}
                                    readOnly
                                    className="me-2"
                                  />
                                  {col.label}
                                </div>
                              );
                            })}
                        </DropdownMenu>
                        </Dropdown>
                    </Col>
                    </Row>

                {loading ? (
                    <div className="text-center text-muted py-4">
                    Loading data...
                    </div>
                ) : filteredData.length === 0 ? (
                    <div className="text-center text-muted py-4">
                    Select filters and click "Apply Filters"
                    </div>
                ) : (
                    <div className="lovable-table-wrapper">
                        <Table responsive className="lovable-table">
                            <colgroup>
                            {/* Date Range fixed width */}
                            <col style={{ width: "200px" }} />

                            {/* Dynamic filter columns */}
                            {appliedFilters.map((_, i) => (
                                <col key={`filter-${i}`} style={{ width: "150px" }} />
                            ))}

                            {/* Metric sub columns (equal width) */}
                            {columns
                                .filter((col) => {
                                  if (
                                    ["ContributionMargin", "profit_contribution", "popularity_contribution", "performance_group"].includes(col.key)
                                  ) {
                                    return col.visible && showContributionColumns;
                                  }
                                  return col.visible;
                                })
                                .map(col => {
                                const meta = COLUMN_META[col.key];
                                const count = meta.type === "triple" ? 3 : 2;

                                return Array.from({ length: count }).map((_, i) => (
                                    <col key={`${col.key}-${i}`} style={{ width: "80px" }} />
                                ));
                                })}
                            </colgroup>
                            <thead>
                            <tr>
                            {/* Always First */}
                            <th rowSpan="2">Date Range</th>

                            {/* Dynamic Applied Filter Columns */}
                            {appliedFilters.map((filter, index) => (
                                <th key={index} rowSpan="2">
                                {filter.name}
                                </th>
                            ))}

                            {/* Metric Groups */}
                            {columns
                            .filter((col) => {
                              if (
                                ["ContributionMargin", "profit_contribution", "popularity_contribution", "performance_group"].includes(col.key)
                              ) {
                                return col.visible && showContributionColumns;
                              }
                              return col.visible;
                            })
                            .map(col => {
                                const meta = COLUMN_META[col.key];
                                const colSpan = meta.type === "triple" ? 3 : 2;

                                return (
                                <th
                                    key={col.key}
                                    colSpan={colSpan}
                                    className="group-header"
                                    style={{ backgroundColor: meta.bg }}
                                >
                                    {meta.multiline ? (
                                    col.label.split(" ").map((word, index) => (
                                        <div key={index}>{word}</div>
                                    ))
                                    ) : (
                                    col.label
                                    )}
                                </th>
                                );
                            })}
                            
                            </tr>

                            <tr className="sub-header">
                            {columns
                                .filter(col => col.visible)
                                .map(col => {
                                const meta = COLUMN_META[col.key];

                                if (meta.type === "triple") {
                                    return (
                                    <React.Fragment key={col.key}>
                                        <th>Current <br/>Year</th>
                                        <th>Last <br/>Year</th>
                                        <th>% <br/>Change</th>
                                    </React.Fragment>
                                    );
                                }

                                return (
                                    <React.Fragment key={col.key}>
                                    <th>Current <br/>Year</th>
                                    <th>% <br/>Change</th>
                                    </React.Fragment>
                                );
                                })}
                            </tr>
                            </thead>

                            <tbody>
                            {filteredData.map((row, index) => {
                                // Assuming API returns data in similar format
                                const coversChange = row.coversCurrent && row.coversLast ? ((row.coversCurrent - row.coversLast) / row.coversLast) * 100 : 0;
                                const avgChange = row.avgCurrent && row.avgLast ? ((row.avgCurrent - row.avgLast) / row.avgLast) * 100 : 0;
                                const revenueChange = row.revenueCurrent && row.revenueLast ? ((row.revenueCurrent - row.revenueLast) / row.revenueLast) * 100 : 0;

                                return (
                                  <tr key={index}>
                                    {/* Date Range */}
                                    {/* <td>
                                      {row.dateRange || row.date_range || "-"}
                                    </td> */}
                                    {(() => {
                                      const span = getRowSpan(
                                        filteredData,
                                        index,
                                        null
                                      );

                                      if (span === 0) return null;

                                      return (
                                        <td rowSpan={span}>
                                          {row.dateRange ||
                                            row.date_range ||
                                            "-"}
                                        </td>
                                      );
                                    })()}

                                    {/* Dynamic Applied Filter Columns */}
                                    {/* {appliedFilters.map((filter, i) => {
                                    if (filter.name === "Day of Week") {
                                      return index === firstDayIndex ? (
                                        <td key={i} rowSpan={sameDayCount}>
                                          {row.day || "-"}
                                        </td>
                                      ) : null;
                                    }

                                    if (filter.name === "Service Periods") {
                                    return <td key={i}>{row.service_periods || '-'}</td>;
                                    }

                                    if (filter.name === "Master Class") {
                                    return <td key={i}>{row.master_class || '-'}</td>;
                                    }

                                    if (filter.name === "Table Occupancy") {
                                    return <td key={i}>{row.occupancy || '-'}</td>;
                                    }

                                    return <td key={i}>-</td>;
                                })} */}
                                    {appliedFilters.map((filter, i) => {
                                      const field = filter.field;

                                      const span = getRowSpan(
                                        filteredData,
                                        index,
                                        filter.name,
                                      );

                                      if (span === 0) return null;

                                      return (
                                        <td key={i} rowSpan={span} className="text-center">
                                          {row[field] || "-"}
                                        </td>
                                      );
                                    })}

                                    {/* Metrics */}
                                    {columns
                                      .filter((col) => {
                                        if (
                                          ["ContributionMargin", "profit_contribution", "popularity_contribution", "performance_group"].includes(col.key)
                                        ) {
                                          return col.visible && showContributionColumns;
                                        }
                                        return col.visible;
                                      })
                                      .map((col) => {
                                        const meta = COLUMN_META[col.key];

                                        // Use actual data or default
                                        const current =
                                          row[`${col.key}Current`] ||
                                          row[`${col.key}_current`] ||
                                          0;
                                        const last =
                                          row[`${col.key}Last`] ||
                                          row[`${col.key}_last`] ||
                                          0;
                                        const change =
                                          current !== 0 && last !== 0
                                            ? ((current - last) / last) * 100
                                            : 0;

                                        if (meta.type === "triple") {
                                          return (
                                            <React.Fragment key={col.key}>
                                              <td>{current}</td>
                                              <td>{last}</td>
                                              <td
                                                className={
                                                  change >= 0
                                                    ? "positive"
                                                    : "negative"
                                                }
                                              >
                                                {change.toFixed(0)}%
                                              </td>
                                            </React.Fragment>
                                          );
                                        }

                                        // DOUBLE COLUMN TYPE
                                        return (
                                          <React.Fragment key={col.key}>
                                            {/* <td>{current}</td> */}
                                            <td>{row[`${col.key}`]}</td>
                                            <td
                                              className={
                                                change >= 0
                                                  ? "positive"
                                                  : "negative"
                                              }
                                            >
                                              {row[`${col.key}_per`]}%
                                            </td>
                                          </React.Fragment>
                                        );
                                      })}
                                  </tr>
                                );
                            })}
                            </tbody>
                        </Table>
                        </div>
                )}
                </CardBody>
            </Card>
            </Container>
        </div>
    </React.Fragment>
  );
}